export const randomColor = (num) => {
    var n = num.slice(-2);

    if(n%10 === 1) 
        return '#ff792e'
    else if(n%10 === 2) 
        return '#5c0099'
    else if(n%10 === 3) 
        return '#04a777'
    else if(n%10 === 4) 
        return '#5465ff'
    else if(n%10 === 5) 
        return '#22577a'
    else if(n%10 === 6) 
        return '#2a9d8f'
    else if(n%10 === 7) 
        return '#0081a7'
    else if(n%10 === 8) 
        return '#e63946'
    else if(n%10 === 9) 
        return '#00cc00'
    else 
        return '#e76f51'
}
